import { getRequestQueryKey } from '../../hooks/use_suspense_api'
import { getMessageFields, getMessagesInclude } from './messages_data_options'

export const getMessagesRequestArgs = ({
  conversation_id,
  reply_root_id,
}: {
  conversation_id: number
  reply_root_id?: string | null
}) => {
  const normalizedReplyRootId = reply_root_id ?? null
  const url = normalizedReplyRootId
    ? `/me/conversations/${conversation_id}/messages/${normalizedReplyRootId}/replies`
    : `/me/conversations/${conversation_id}/messages`

  return {
    url,
    data: {
      perPage: 25,
      fields: getMessageFields,
      include: getMessagesInclude,
    },
    reply_root_id: normalizedReplyRootId,
  }
}

export const getMessagesQueryKey = ({
  conversation_id,
  reply_root_id,
}: {
  conversation_id: number
  reply_root_id?: string | null
}) => {
  const requestArgs = getMessagesRequestArgs({ conversation_id, reply_root_id })
  return getRequestQueryKey(requestArgs)
}
